import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicAsyncSelect, BaasicInput, BaasicSelect } from 'core/components';
import { translate } from 'core/utils';

function AddExistingProductModalContentTemplate({ addExistingProductModalContentViewStore, t }) {
	const {
		addExistingProductForm,
		selectedProduct,
		onProductChange,
		isProductDropdownLoading,
		debouncedProductSearch,
		productOptions,
		onMenuClose,
		isSaveClicked,
		goBackToProductPartTypeSelection,
		isBackClicked,
		handleOnProductMenuScroll,
	} = addExistingProductModalContentViewStore;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={addExistingProductForm.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('PRODUCTDETAILVIEW.ADDPRODUCTPARTMODAL.ADDEXISTINGPRODUCT')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="row">
						<div className="col col-sml-12 col-lrg-6">
							<BaasicSelect
								field={addExistingProductForm.$('product')}
								value={selectedProduct}
								onChange={onProductChange}
								isLoading={isProductDropdownLoading}
								onMenuScrollToBottom={handleOnProductMenuScroll}
								options={productOptions.slice()}
								onInputChange={debouncedProductSearch}
								onMenuClose={onMenuClose}
							/>
						</div>
						<div className="col col-sml-12 col-lrg-6">
							<BaasicInput field={addExistingProductForm.$('quantity')} showCheckmark={false} />
						</div>
						{addExistingProductForm.error && (
							<div className="col col-sml-12">
								<p className="type--color--warning spc--bottom--sml">{translate(addExistingProductForm.error)}</p>
							</div>
						)}
					</div>
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={isSaveClicked || isBackClicked}>
						{t('SAVE')}
					</button>
					<button
						className="btn btn--med btn--ghost spc--bottom--sml"
						type="button"
						onClick={goBackToProductPartTypeSelection}
						disabled={isSaveClicked || isBackClicked}
					>
						{t('BACK')}
					</button>
				</div>
			</form>{' '}
		</section>
	);
}

export default defaultTemplate(AddExistingProductModalContentTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/AddExistingProductModalContentTemplate.jsx